import type { ReferenceRendererProps } from '@contember/react-client'
import type { ContentBlockReference } from '../../app/data/content/ContentFragment'
import { ProductList } from '../Products'

export const products = ({ reference }: ReferenceRendererProps<ContentBlockReference>) => {
	return <ProductList title={reference.primaryText} products={reference.productList} />
}
